export const ActiveGreen = () => {
    return (
        <svg aria-hidden width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_8410_340)">
                <rect x="0.505859" width="32" height="32" rx="16" fill="#C2E2C4" />
                <path
                    d="M22.3496 19.275C23.5184 18.9438 24.5934 20.025 23.8871 21.0312C22.4059 23.4125 19.6496 24.9438 16.4996 24.9438C13.3559 24.9438 10.5996 23.4125 9.06211 21.0312C8.41211 20.025 9.48711 18.9438 10.6496 19.275C12.4621 19.6938 14.4309 19.925 16.4996 19.925C18.5684 19.925 20.5434 19.6938 22.3496 19.275ZM13.5309 13C13.5309 14.1062 12.6309 15 11.5309 15C10.4246 15 9.53086 14.1062 9.53086 13C9.53086 11.8938 10.4246 11 11.5309 11C12.6309 11 13.5309 11.8938 13.5309 13ZM19.5309 13C19.5309 11.8938 20.4246 11 21.5309 11C22.6309 11 23.5309 11.8938 23.5309 13C23.5309 14.1062 22.6309 15 21.5309 15C20.4246 15 19.5309 14.1062 19.5309 13ZM32.5059 16C32.5059 24.8375 25.3434 32 16.5059 32C7.66836 32 0.505859 24.8375 0.505859 16C0.505859 7.1625 7.66836 0 16.5059 0C25.3434 0 32.5059 7.1625 32.5059 16ZM16.5059 3C9.32461 3 3.50586 8.81875 3.50586 16C3.50586 23.1812 9.32461 29 16.5059 29C23.6871 29 29.5059 23.1812 29.5059 16C29.5059 8.81875 23.6871 3 16.5059 3Z"
                    fill="#006E1D"
                />
            </g>
            <defs>
                <clipPath id="clip0_8410_340">
                    <rect x="0.505859" width="32" height="32" rx="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
